import React from 'react';
import HomeHero from '@/components/sections/HomeHero';
import WhyItWorks from '@/components/sections/WhyItWorks';
import WhoWeWorkWith from '@/components/sections/WhoWeWorkWith';
import HowItWorks from '@/components/sections/HowItWorks';
import WhatWeOptimize from '@/components/sections/WhatWeOptimize';
import WhySellrly from '@/components/sections/WhySellrly';

export default function Home() {
  return (
    <div data-testid="page-home">
      <HomeHero />
      <WhyItWorks />
      <WhoWeWorkWith />
      <HowItWorks />
      <WhatWeOptimize />
      <WhySellrly />
    </div>
  );
}
